module.exports = __webpack_public_path__ + "img/Frame 1321315129@2x.95e595cd.png";